import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {createStore, combineReducers, applyMiddleware} from 'redux';
import {Provider} from 'react-redux';
import ReduxThunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import App from './components/App';
import * as serviceWorker from './serviceWorker';
import './scss/main.scss';
import calculatorReducer from './store/reducers/calculatorReducer';
import {IntlProvider} from 'react-intl'
import {parseSearchQuery} from "./store/actions/calculatorActions";

function loadLocaleData(locale) {
  switch (locale) {
    case 'en':
      return import('./compiled-lang/en.json')
    case 'nl':
      return import('./compiled-lang/nl.json')
    default:
      return import('./compiled-lang/nl.json')
  }
}

// npm run extract -- 'src/**/*.js*' --ignore='**/*.d.js' --out-file lang/nl.json --id-interpolation-pattern '[sha512:contenthash:base64:6]'


const rootReducer = combineReducers({
    calculator: calculatorReducer
});

export const store = createStore(rootReducer, composeWithDevTools(
    applyMiddleware(ReduxThunk),
));

async  function init() {

  const requestParams = parseSearchQuery(window.location.search, true);

  const locale = requestParams?.lang ? requestParams?.lang : window.location.pathname.includes('/en/') ? 'en' : 'nl';
  const messages = await loadLocaleData(locale)

  ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <IntlProvider messages={messages} locale={locale}>
        <App/>
      </IntlProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
  );

}

init();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
